import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
export const useUploadFile = () => {
    return useMutation({
        mutationFn: ({ files, conversationId }: { files: File[]; conversationId?: string }) =>
            chatService.uploadFile(files, conversationId),
    });
};
